import { StatesData } from '../Member/StatesData';

const clean = value => String(value ?? '').trim();

// The printable-disc prefix: state code / first two LGA letters / department code-.
export function generateMembershipPrefix(data = {}) {
  const state = StatesData.find(item => item.state.toLowerCase() === clean(data.stateoforigin).toLowerCase());
  const lga = state?.lgas.find(item => item.toLowerCase() === clean(data.lga).toLowerCase());
  if (!state || !lga) return '';
  const department = ({ 'mother body': 'MB', 'first aid': 'FA', 'women wing': 'WW' })[clean(data.department).toLowerCase()] || '';
  return `${state.abbr || state.abrr}/${lga.slice(0, 2).toUpperCase()}/${department}-`;
}

export function getMembershipPrefix(data = {}) {
  // Honour the prefix saved by the print editor, including manually assigned prefixes.
  return clean(clean(data.id_ref_num) || generateMembershipPrefix(data)).replace(/^FIN\//i, '').replace(/^\/+|\/+$/g, '');
}

export function getMembershipReference(data = {}) {
  return [getMembershipPrefix(data), clean(data.r_ID)].filter(Boolean).join('/');
}
